export default {
  'chat.avatar': '头像',
  'chat.placeholder': '...',
  'tokenTag.overload': '超额',
  'tokenTag.remained': '剩余',
  'tokenTag.used': '已用',
} as const;
